import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import baseQueryWithReauth from './base';

export interface BinData {
  id: string;
  bin: string;
  scheme: string;
  type: string;
  issuer: string;
  tier: string;
  country: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  payway_code: number;
  allowed_installments: number[];
}

const binsApi = createApi({
  reducerPath: 'binsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['bins'],
  endpoints: (build) => ({
    getBinData: build.query<BinData | null, { bin: string }>({
      query: ({ bin }) => ({
        url: `/bins/${bin}`,
        method: 'GET',
      }),
      transformResponse: (response: Response<BinData>): (BinData | null) => response.data || null,
    }),
  }),
});

export const {
  useGetBinDataQuery,
  useLazyGetBinDataQuery,
} = binsApi;

export { binsApi };
